import { OTSPartOriginEnum, PartOrigin } from '@luminovo/api-contracts';

export const otsPartOriginKeyWithLabelValue: Record<OTSPartOriginEnum, { label: string }> = {
    [OTSPartOriginEnum.Manual]: { label: 'Manual' },
    [OTSPartOriginEnum.System]: { label: 'System' },
    [OTSPartOriginEnum.Import]: { label: 'Import' },
    [OTSPartOriginEnum.Aggregate]: { label: 'Aggregate' },
    [OTSPartOriginEnum.DescriptionExtraction]: { label: 'DescriptionExtraction' },
    [OTSPartOriginEnum.SupplierPortal]: { label: 'Supplier Portal' },
    // ----
    [OTSPartOriginEnum.AlfatecAPI]: { label: 'Alfatec' },
    [OTSPartOriginEnum.ArrowAPI]: { label: 'Arrow' },
    [OTSPartOriginEnum.AvnetAPI]: { label: 'Avnet' },
    [OTSPartOriginEnum.AvnetUsaAPI]: { label: 'Avnet USA' },
    [OTSPartOriginEnum.BuerklinAPI]: { label: 'Bürklin' },
    [OTSPartOriginEnum.ChipAssistAPI]: { label: 'Chip Assist' },
    [OTSPartOriginEnum.DigikeyAPI]: { label: 'DigiKey' },
    [OTSPartOriginEnum.Element14API]: { label: 'element14' },
    [OTSPartOriginEnum.EveAPI]: { label: 'EVE' },
    [OTSPartOriginEnum.FarnellAPI]: { label: 'Farnell' },
    [OTSPartOriginEnum.FutureAPI]: { label: 'Future Electronics' },
    [OTSPartOriginEnum.GreenchipsAPI]: { label: 'GREENCHIPS' },
    [OTSPartOriginEnum.GudecoAPI]: { label: 'Gudeco' },
    [OTSPartOriginEnum.HeilindAPI]: { label: 'Heilind' },
    [OTSPartOriginEnum.HexachipAPI]: { label: 'Hexachip' },
    [OTSPartOriginEnum.IHSImport]: { label: 'Accuris (IHS)' },
    [OTSPartOriginEnum.MasterAPI]: { label: 'Master Electronics' },
    [OTSPartOriginEnum.MouserAPI]: { label: 'Mouser' },
    [OTSPartOriginEnum.MyArrowAPI]: { label: 'MyArrow' },
    [OTSPartOriginEnum.LcscAPI]: { label: 'LCSC' },
    [OTSPartOriginEnum.NewarkAPI]: { label: 'Newark' },
    [OTSPartOriginEnum.OctopartAPI]: { label: 'Octopart' },
    [OTSPartOriginEnum.OnlineComponentsAPI]: { label: 'Online Components' },
    [OTSPartOriginEnum.RapidElectronicsAPI]: { label: 'Rapid Electronics' },
    [OTSPartOriginEnum.RmComponentsAPI]: { label: 'RM Components' },
    [OTSPartOriginEnum.RsComponentsAPI]: { label: 'RS Components' },
    [OTSPartOriginEnum.RochesterAPI]: { label: 'Rochester Electronics' },
    [OTSPartOriginEnum.QuestComponentsAPI]: { label: 'Quest Components' },
    [OTSPartOriginEnum.RutronikAPI]: { label: 'Rutronik' },
    [OTSPartOriginEnum.SchukatAPI]: { label: 'Schukat' },
    [OTSPartOriginEnum.SiliconExpertAPI]: { label: 'SiliconExpert' },
    [OTSPartOriginEnum.SluiceboxAPI]: { label: 'Sluicebox' },
    [OTSPartOriginEnum.SosAPI]: { label: 'SOS Electronic' },
    [OTSPartOriginEnum.EcomalAPI]: { label: 'Ecomal' },
    [OTSPartOriginEnum.SourcengineAPI]: { label: 'Sourcengine' },
    [OTSPartOriginEnum.TelconaAPI]: { label: 'Telcona' },
    [OTSPartOriginEnum.TiAPI]: { label: 'Texas Instruments' },
    [OTSPartOriginEnum.TtiAPI]: { label: 'TTI' },
    [OTSPartOriginEnum.TmeAPI]: { label: 'TME' },
    [OTSPartOriginEnum.TrustedPartsAPI]: { label: 'TrustedParts' },
    [OTSPartOriginEnum.VenkelAPI]: { label: 'Venkel' },
    [OTSPartOriginEnum.WeltronAPI]: { label: 'Weltron' },
    [OTSPartOriginEnum.WuerthEisosAPI]: { label: 'Würth Elektronik eiSos' },
    [OTSPartOriginEnum.CorestaffAPI]: { label: 'Corestaff' },
    [OTSPartOriginEnum.BlumeAPI]: { label: 'Blume' },
    [OTSPartOriginEnum.SamtecAPI]: { label: 'Samtec' },
    [OTSPartOriginEnum.AlElektronikAPI]: { label: 'Al Elektronik' },
    [OTSPartOriginEnum.AvnetApacAPI]: { label: 'Avnet Asia Pacific' },
    [OTSPartOriginEnum.ChipCartAPI]: { label: 'ChipCart' },
    [OTSPartOriginEnum.WinSourceAPI]: { label: 'WinSource' },
    [OTSPartOriginEnum.WittigAPI]: { label: 'Wittig Electronic' },
    [OTSPartOriginEnum.IcHubAPI]: { label: 'icHub' },
    [OTSPartOriginEnum.UnikeyAPI]: { label: 'Unikey' },
    [OTSPartOriginEnum.VPL]: { label: 'VPL' },
    [OTSPartOriginEnum.Supplyframe]: { label: 'Supplyframe' },
    [OTSPartOriginEnum.KruseAPI]: { label: 'Kruse' },
    [OTSPartOriginEnum.IneltroAPI]: { label: 'Ineltro' },
    [OTSPartOriginEnum.AtlantikNetworxxAPI]: { label: 'Atlantik Networxx' },
    [OTSPartOriginEnum.BossardAPI]: { label: 'Bossard' },
    [OTSPartOriginEnum.MevAPI]: { label: 'MEV Elektronik' },
};

export function formatOtsPartOrigin(origin: PartOrigin) {
    let key =
        origin.type === OTSPartOriginEnum.DescriptionExtraction && origin.data && 'origin' in origin.data
            ? origin.data.origin.type
            : origin.type;
    return otsPartOriginKeyWithLabelValue[key]?.label ?? key;
}
